<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right" style="margin: 4.8vw 7.733vw;">
            <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
            <el-breadcrumb-item>FAQs</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="bg">
            <img src="../assets/imgs/uploads/mobile/faqbg.png" alt="" style="width: 100%;">
            <div class="search">
                <div style="font-size: 6.4vw;font-weight: bold;color: #FFF;margin-bottom: 6.933vw;width: 77.333vw;">
                    Search for your question</div>
                <div style="position: relative;">
                    <el-input v-model="searchQuery" @keyup.enter.native="searchText"
                        placeholder="Enter your search term here..."></el-input>
                    <div class="shbtn" @click="searchText">
                        <img src="../assets/imgs/uploads/mynaui_search.png" style="width: 6.933vw;height: 6.933vw;" alt="">
                    </div>
                </div>
                <div class="add">
                    <img src="../assets/imgs/uploads/Group 3911.png"
                        style="width: 4.267vw;height: 4.267vw;background-color: #CA141D;" alt="">
                    <span style="font-size: 4.267vw;color: #FFF;margin-left: 2.4vw;" @click="taggle">Help & Contact
                        us</span>
                </div>
            </div>
        </div>
        <div v-if="status == '1'" class="wrps">
            <el-collapse v-model="activeNames1">
                <el-collapse-item name="1">
                    <template slot="title">
                        <img src="../assets/imgs/uploads/mingcute_question-fill.png" style="width: 6.4vw;height: 6.4vw;"
                            alt="">
                        <div style="margin-left: 2.667vw;">Gernerals </div>
                    </template>
                    <div style="margin: 4.533vw 7.733vw 0;">
                        <div v-html="highlightText(content1)" class="ques">
                        </div>
                    </div>
                </el-collapse-item>
                <el-collapse-item name="2">
                    <template slot="title">
                        <img src="../assets/imgs/uploads/fa-solid_shipping-fast.png" style="width: 6.4vw;height: 4.533vw;"
                            alt="">
                        <div style="margin-left: 2.667vw;">Products </div>
                    </template>
                    <div style="margin: 4.533vw 7.733vw 0;">
                        <div v-html="highlightText(content2)" class="ques">
                        </div>
                    </div>
                </el-collapse-item>
                <el-collapse-item name="3">
                    <template slot="title">
                        <img src="../assets/imgs/uploads/fluent_payment-20-filled.png" style="width: 6.4vw;height: 6.4vw;"
                            alt="">
                        <div style="margin-left: 2.667vw;">Order/Payment/Transportation </div>
                    </template>
                    <div style="margin: 4.533vw 7.733vw 0;">
                        <div v-html="highlightText(content3)" class="ques">
                        </div>
                    </div>
                </el-collapse-item>
                <el-collapse-item name="4">
                    <template slot="title">
                        <img src="../assets/imgs/uploads/ep_promotion.png" style="width: 6.4vw;height: 6.4vw;" alt="">
                        <div style="margin-left: 2.667vw;">After-sales service </div>
                    </template>
                    <div style="margin: 4.533vw 7.733vw 0;">
                        <div v-html="highlightText(content4)" class="ques">
                        </div>
                    </div>
                </el-collapse-item>
            </el-collapse>
        </div>
        <div v-else class="help">
            <div style="margin-top: 9.6vw;font-weight: bold;font-size: 5.333vw;">Help & Contact us</div>
            <p style="margin-top: 5.067vw;">Still can't find what you're looking for? Please fill out the form below and
                we’ll get back to you right away! Or contact customer care at 0086 400-870-1705.</p>
            <el-form style="margin-top: 8vw;" :model="ValidateForm" ref="ValidateForm" label-position="top"
                class="demo-ruleForm">
                <el-form-item label="Your email" prop="email" :rules="[
                    { required: true, message: 'please enter your Email', trigger: 'blur' },
                    { type: 'email', message: 'Please input the correct email address', trigger: ['blur', 'change'] }
                ]">
                    <el-input v-model="ValidateForm.email" placeholder="Enter your email" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="Your name" prop="name" :rules="[
                    { required: true, message: 'name cannot be left blank.' },
                ]">
                    <el-input v-model="ValidateForm.name" placeholder="Enter your name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="Type" prop="type"
                    :rules="[{ required: true, message: 'Please select a type', trigger: 'change' }]">
                    <el-select v-model="ValidateForm.type" placeholder="-Please select a type">
                        <el-option label="Payment" value="payment"></el-option>
                        <el-option label="Shipping" value="shipping"></el-option>
                        <el-option label="Returns" value="returns"></el-option>
                        <el-option label="Place an order" value="place an order"></el-option>
                        <el-option label="Order Status" value="order status"></el-option>
                        <el-option label="Other enquiry" value="other enquiry"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Order number" prop="number">
                    <el-input v-model="ValidateForm.number" placeholder="Enter your Order number" autocomplete="off"
                        class="two"></el-input>
                </el-form-item>
                <el-form-item label="Subject" prop="subject">
                    <el-input v-model="ValidateForm.subject" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="Description" prop="description" :rules="[
                    { required: true, message: 'Please provide a description.', trigger: 'blur' }]">
                    <el-input type="textarea" :rows="9" v-model="ValidateForm.description"></el-input>
                </el-form-item>
                <div style="display: flex;justify-content: space-between;">
                    <el-form-item>
                        <el-button type="primary" class="back" @click="taggle()">Back</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" class="submit" @click="submitForm('ValidateForm')">Submit</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            userInfo: null,
            searchQuery: '',
            status: '1',
            ValidateForm: {
                email: '',
                name: '',
                type: '',
                number: '',
                subject: '',
                description: '',
            },
            activeNames1: ['1'],
            content1: `<div>1. How can I become a customer ?</div>
                         <p>
                            We currently partner with distributors in international markets, so individual customers cannot purchase GiGwi products directly from us. However, if you are interested in becoming a GiGwi distributor, you can register an account with us. To do so, please fill out the registration form. Once we receive your submission, we will review your application and get in touch with you as soon as possible. Alternatively, you can contact us at info@gigwi.com.hk.
                        </p>
                        <hr>
                        <div>2.What requirments do I have to meet to become a distributor ?</div>
                        <p>In general, we kindly request that our distributors meet the following conditions:
                        </p>
                        <p>● Maintain a strong reputation and a reliable track record in the distribution of pet products.</p>
                        <p>● Have appropriate warehouse space and facilities to safely store products.</p>
                        <p>● Store and maintain sufficient product inventory in your warehouse facilities to meet customer demand.</p>
                        <p>Upon receiving your application, we will carefully review it based on the requirements of the specific market and respond to you as soon as possible. Kindly note that in some regions, we may already be working with a distributor or an exclusive partner.</p>
                        <hr>
                        <div>3.How can I place an order ?</div>
                        <p>
                            Once you have requested and received your login credentials, you can access our webshop to place your order directly. Alternatively, you may also place orders through your assigned representative.
                        </p>                       
                        <hr>
                        `,
            content2: `<div>1. Why can't I see prices on the website ?</div>
                        <p>At this time, we do not sell directly to end-customers. Therefore, if you are an individual customer, you will not be able to purchase GiGwi products directly from us, which is why prices are not displayed on our website.</p>
                        <p>For distributors, we kindly request that you submit an application form. Once your application has been reviewed and approved, you will receive login credentials, which will grant you access to view prices.</p>
                        <hr>
                        <div>2. Can I get a catalogue ?</div>
                        <p>
                            If you are interested in becoming a distributor, please contact us or fill out the registration form. Once submitted, our sales representatives will review the cooperation details with you.
                        </p>
                        <hr>
                        `,
            content3: `<div>1. Where is our warehouse located ?</div>
                       <p>Our warehouse is located in Nanjing, Jiangsu, China</p>
                       <hr>
                       <div>2. How is the shipping cost calculated ?</div>
                       <p>We provide offers based on EXW or FOB Shanghai, depending on the order amount. Most of our current customers work with their own forwarding agents to consolidate shipments. However, if you require a different shipping term, such as DDP or DDU, please let us know. We can consult with our forwarder and provide you with a separate quote.</p>
                        <hr>
                        `,
            content4: `<div>1. How do I contact customer service?</div>
                       <P>If you encounter any issues with your order, please contact the relevant department for quicker assistance:</p>
                       <P>●If you purchased from a store, please reach out to the store directly.</p>
                       <p>●If you purchased through a distributor, contact the distributor.</p>
                       <p>●If you purchased directly from GiGwi, you can reach us at info@gigwi.com.hk.</p>
                       <hr>
                       <div>2. What is our return policy?</div>
                       <p>If there are quality issues with your order, please contact the seller directly to arrange a return or exchange. The process involves step-by-step feedback, and if necessary, we will facilitate a replacement or refund for quality-related concerns.</p>
                       <hr>
                       `,
        }
    },
    activated() {
        this.status = '1'
    },
    mounted() {
        const storedUserInfo = localStorage.getItem('user');
        // 判断是否存在用户信息
        if (storedUserInfo) {
            this.userInfo = JSON.parse(storedUserInfo);
        }
    },
    methods: {
        highlightText(text) {
            if (!this.searchQuery) return text;
            const regex = new RegExp(this.searchQuery, 'gi');
            let isFirstMatch = true; // 标记第一个匹配项，以便后续滚动
            return text.replace(regex, (match) => {
                const result = `<span class="highlight123">${match}</span>`;
                if (isFirstMatch) {
                    isFirstMatch = false;
                    return `<span class="highlight123" id="first-match">${match}</span>`;
                }
                return result;
            });
        },
        searchText() {
            this.resetSearch();
            // 检查每个内容块是否包含搜索关键词
            const contents = [this.content1, this.content2, this.content3, this.content4,];
            contents.forEach((content, index) => {
                if (content.toLowerCase().includes(this.searchQuery.toLowerCase())) {
                    this.activeNames1.push(String(index + 1));  // 添加到 activeNames 以展开对应的折叠项
                }
            });
            this.$nextTick(() => {
                setTimeout(() => {  // 添加延时以确保 DOM 更新完成
                    const element = document.getElementById('first-match');
                    if (element) {
                        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                }, 300);
            });
        },
        resetSearch() {
            this.activeNames1 = [];  // 重置折叠状态
        },
        taggle() {
            if (this.status == '1') {
                this.status = '0'
            } else {
                this.status = '1'
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                const param = {
                    ...JSON.parse(JSON.stringify(this.ValidateForm)),
                    userId: this.userInfo ? this.userInfo.id : '',
                    userName: this.userInfo ? this.userInfo.nickName : '',
                }
                if (valid) {
                    this.$axios
                        .post("/api/mall/contact/save", param)
                        .then(res => {
                            if (res.data.code === 200) {
                                this.$message({
                                    message: 'Message sent successfully!',
                                    type: 'success'
                                });
                                this.$router.push({ path: "/finishedregister" });
                            } else {
                                this.notifyError(res.data.message);
                            }
                        })
                        .catch(err => {
                            return Promise.reject(err);
                        });
                } else {
                    return false;
                }
            });
        },
    }
}
</script>

<style scoped>
.bg {
    position: relative;
}

.search {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.shbtn {
    position: absolute;
    top: 48%;
    right: 1%;
    transform: translate(-50%, -50%);
}

.add {
    margin-top: 19px;
    display: flex;
    align-items: center;
}

.wrps {
    margin-bottom: 72px;
}


.ques ::v-deep div {
    font-size: 17px;
    font-weight: bold;
    color: #000;
    margin-bottom: 20px;
}

.ques ::v-deep p {
    font-size: 15px;
}

.ques ::v-deep hr {
    color: #B4BAC1;
}

::v-deep .el-collapse-item__header {
    background-color: #CA141D;
    height: 54px;
    font-size: 17px;
    font-weight: bold;
    color: #FFF;
    padding-left: 27px;
}

::v-deep .el-collapse-item__header.focusing:focus:not(:hover) {
    color: #FFF;
}

::v-deep .el-collapse-item__arrow {
    margin: 0;
}

::v-deep .el-collapse-item__wrap {
    border: none;
}

.ques ::v-deep .highlight123 {
    background-color: yellow !important;
}

.help {
    padding: 0 29px;
    font-size: 16px;
}

::v-deep .two1 .el-input__inner:focus {
    border-color: #CA141D !important;
}

::v-deep .el-select .el-input.is-focus .el-input__inner {
    border-color: #CA141D;
}

::v-deep .el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
    background-color: #CA141D !important;
    color: #FFF !important;
}

::v-deep .el-form-item__label {
    text-align: left;
}

.el-select-dropdown__item.selected {
    color: #000;
}

::v-deep .el-textarea__inner:focus {
    border-color: #000;
}

::v-deep .el-textarea__inner {
    resize: none;
}

.back {
    width: 151px;
    height: 42px;
    background-color: #565656;
    border: #565656;
}

.submit {
    width: 151px;
    height: 42px;
}
</style>